// Session Management Utilities

/**
 * Handle session expiration (401/403 responses)
 * @param {number} status - HTTP status code (401 or 403)
 */
export const handleSessionExpiration = (status = 401) => {
  // Clear all authentication data
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminInfo');
  
  // Set appropriate message based on status
  const message = status === 403 
    ? 'Session expired due to security reasons. Please login again.'
    : 'Session expired. Please login again.';
  
  // Store message for login page to display
  sessionStorage.setItem('sessionMessage', message);
  
  // Redirect to login page
  window.location.href = '/login';
};

/**
 * Check if session is about to expire (optional enhancement)
 * @param {number} expiresInMinutes - Token expiration time in minutes
 */
export const checkTokenExpiration = (expiresInMinutes = 30) => {
  const token = sessionStorage.getItem('token') || sessionStorage.getItem('adminToken');
  if (!token) return false;
  
  try {
    // Parse JWT token (basic implementation)
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expirationTime = payload.exp * 1000; // Convert to milliseconds
    const currentTime = Date.now();
    const timeUntilExpiration = expirationTime - currentTime;
    
    // Show warning if token expires within 5 minutes
    if (timeUntilExpiration < 5 * 60 * 1000 && timeUntilExpiration > 0) {
      return {
        isExpiringSoon: true,
        timeLeft: Math.floor(timeUntilExpiration / 1000 / 60) // minutes
      };
    }
    
    return {
      isExpiringSoon: false,
      isExpired: timeUntilExpiration <= 0
    };
  } catch (error) {
    console.error('Error parsing token:', error);
    return false;
  }
};

/**
 * Clear all session data
 */
export const clearSession = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('adminInfo');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('adminToken');
  sessionStorage.clear();
};

/**
 * Get session message and clear it
 * @returns {string|null} Session message if exists
 */
export const getSessionMessage = () => {
  const message = sessionStorage.getItem('sessionMessage');
  if (message) {
    sessionStorage.removeItem('sessionMessage');
    return message;
  }
  return null;
};
